/*global FormController, WebView, $*/


var depositPopupController = new FormController("account_payment", 
    {
        directory: "views/deposit",
        name: "depositPopup",
        route: "deposit-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        defaultData: { },
        popup: {
            size: "medium"
        }
    }
);
/**
 * Add sale settings
 */
depositPopupController.prepareDataOnEnter = function(receivedData, callback){
    var data = {} ;
    data.payment_date = new Date();
    data.res_model = receivedData.res_model;
    data.res_id = receivedData.res_id;
    data.partner_id = receivedData.partner_id,
    data.company_id = receivedData.company_id,
    data.currency_id = receivedData.currency_id,
    data.communication = receivedData.communication ;
    data.date_order = receivedData.date_order ;
    callback(null, data) ;
} ;

depositPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        this.setMode("create") ;
    }
} ;

depositPopupController.onJournal_id = function(){
    this.view.updateData() ;
    if(!this.data.journal_id){
        this.data.isRef = false ;
        this.data.isTicket = false ;
        this.view.render() ;
        return;
    }
    this.view.longTask(function(done){
        this.api.db.account_journal.searchFirst({id: this.data.journal_id}, function(err, journal){
            if(err){ return done(err) ;}
            this.data.isRef = journal.iz_input_reference ;
            this.data.isTicket = journal.iz_input_as_tickets ;
            this.data.refLabel = journal.iz_reference_label || WebView.tr("fields.account_payment.payment_reference") ;
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

depositPopupController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    var records = [] ;
    var pay = {
        payment_date: viewData.payment_date,
        journal_id: viewData.journal_id,
        amount: viewData.amount,
        payment_reference: viewData.payment_reference,
        iz_ticket_amount: viewData.iz_ticket_amount,
        iz_ticket_count: viewData.iz_ticket_count,
    } ;
    records.push({
        table: "account_payment",
        action: "insert",
        record : pay
    }) ;
    this.api.db.multiread({
        account_payment_method: { searchFirst: {payment_type : "inbound", code: "manual"} },
    }, function(err, reads){
        if(err){ return callback(err) ;}
        pay.payment_method_id = reads.account_payment_method.id;
        pay.partner_type = "customer";
        pay.partner_id = this.data.partner_id;
        pay.currency_id = this.data.currency_id;
        pay.company_id = this.data.company_id;
        pay.communication = this.data.number;
        pay.state = "posted";
        pay.payment_type = "inbound";
        pay.payment_difference_handling = "open";
        pay.writeoff_label = "Write-Off";
        pay.iz_is_deposit = true;
        pay.iz_deposit_model = this.data.res_model;
        pay.iz_deposit_res_id = this.data.res_id;

        callback(null, records) ;
    }.bind(this));
};

depositPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};
depositPopupController.onCancel = function(){
    this.view.close() ;
};
depositPopupController.onValidate = function(){
    let dateOrder = this.data.date_order;
    let orderDate = new Date(dateOrder);
    let datePayment = this.view.EL.paymentDate.getValue();
    if(datePayment<orderDate){
        WebView.confirm(WebView.tr("pay.confirmValidationOrder"), function(yes){
            if(yes){  
                this.view.longTask(function(done){
                    this.doValidate(function(err, savedRecord){
                        if(err){ return done(err); }
                        if(!savedRecord){
                            //check failed
                            return done() ;
                        }
                        this.mode = 'read' ; //avoid abort input warning
                        this.view.close() ;
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }
        }.bind(this)) ;
    }else{
        this.view.longTask(function(done){
            this.doValidate(function(err, savedRecord){
                if(err){ return done(err); }
                if(!savedRecord){
                    //check failed
                    return done() ;
                }
                this.mode = 'read' ; //avoid abort input warning
                this.view.close() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }   
};



module.exports = depositPopupController ;